import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c547d8ca&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c547d8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c547d8ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c547d8ca')) {
      api.createRecord('c547d8ca', component.options)
    } else {
      api.reload('c547d8ca', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c547d8ca&scoped=true&", function () {
      api.rerender('c547d8ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eKj0yD3V9saX/JS/comp/GuestBox.vue"
export default component.exports